import ApiFetcher from "../utils/ApiFetcher";
import { put, call } from "redux-saga/effects";
import { makeQueryString } from "../utils/urls";
import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaSearchSuccess,
  sagaCreateSuccess,
  sagaUpdateSuccess
} from "../actions/ActionTypes";
import { showSuccessMsg, showErrorMsg } from "../actions";

const NOTICES = "NOTICES";
const NOTICE = "NOTICE";
const apiFetcher = new ApiFetcher();
export function* fetchNotices(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `notices?${queryString}`);
    yield put({
      type: sagaListSuccess(NOTICES),
      data: res.data
    });
  } catch (e) {}
}

export function* searchNotices(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `notices?${queryString}`);
    yield put({
      type: sagaSearchSuccess(NOTICES),
      data: res.data
    });
  } catch (e) {}
}

export function* fetchNotice(action) {
  try {
    const res = yield call(apiFetcher.find, "notices", action.id);
    yield put({
      type: sagaOneSuccess(NOTICE),
      data: res.data
    });
  } catch (e) {}
}

export function* createNotice(action) {
  try {
    const res = yield call(apiFetcher.create, "notices", {
      notice: action.data
    });

    yield put({
      type: sagaCreateSuccess(NOTICE),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Notice created successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}

export function* updateNotice(action) {
  //restore old data to form when save fails -> probably in reducer
  try {
    const res = yield call(
      apiFetcher.update,
      "notices",
      { notice: action.data },
      action.id
    );

    yield put({
      type: sagaUpdateSuccess(NOTICE),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Notice details updated successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}



// WEBPACK FOOTER //
// ./src/sagas/notices.js